import React from 'react';
import { HashLink as NavLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import * as Text from '../../../constants/translations/account';
import { useSelector } from 'react-redux';

export const AccountSidebar = () => {
	const accountState = useSelector(state => state.account);
	let currentDate = new Date();
	let timeDiff = Math.abs(currentDate.getTime() - accountState.user.lastPasswordChangedDate.getTime());
	let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	

	return (
		<div className="navbar navbar-expand-lg navbar-light">
			{/* <!-- Responsive Toggle Button --> */}
			<button type="button" className="btn w-100 bg-common d-lg-none rounded-0" aria-label="Toggle navigation" aria-expanded="false" aria-controls="sidebarNav" data-bs-toggle="collapse" data-bs-target="#sidebarNav">
				<span className="d-flex justify-content-between align-items-center">
					<span className="mb-0">{Text.NavigateTo[accountState.user.language]}</span>
					<span className="navbar-toggler-default">
						<i className="icns mdi mdi-chevron-down h5"></i>
					</span>
				</span>
			</button>
			{/* <!-- End Responsive Toggle Button --> */}

			<div id="sidebarNav" className="collapse navbar-collapse bg-body">
				<div className="flex-column gap-5 p-2 p-lg-0 w-lg-x8">
					<div className="flex-column">
						<h3 className="h4"><Link className="text-decoration-none" to="/account/general">{Text.Main[accountState.user.language]}</Link></h3>
						<NavLink smooth className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/general#section_personalDetails">
							{Text.Account[accountState.user.language]}
							{diffDays > 30 && 
								<span className="badge rounded-1 py-2 bg-alert-warning border-none">⚠️</span>
							}
						</NavLink>
						<NavLink smooth className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/general#section_updatePassword">
							{Text.Password[accountState.user.language]}
						</NavLink>
						<NavLink smooth className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/general#section_supprimer">
							{Text.Delete[accountState.user.language]}
						</NavLink>
					</div>
					{/* <div className="flex-column">
						<h3 className="h4"><Link className="text-decoration-none" to="/account/settings">{Text.Settings[accountState.user.language]}</Link></h3>
						<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/settings#section_privacy">
							{Text.Privacy[accountState.user.language]}
							<span className="badge badge-pill badge-light">4</span>
						</NavLink>
						<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/settings#section_notifications">
							{Text.Notifications[accountState.user.language]}
						</NavLink>
							<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/settings#section_preferences">
							{Text.Preferences[accountState.user.language]}
						</NavLink>
					</div>
					<div className="flex-column">
						<h3 className="h4"><Link className="text-decoration-none" to="/account/storage">{Text.Data[accountState.user.language]}</Link></h3>
						<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/storage#section_gdpr">
							<span className="flex-shrink-1">{Text.GDPR[accountState.user.language]}</span>
							<span className="badge border badge-pill text-bg-info">9+</span>
						</NavLink>
						<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/storage#section_takeout">
							{Text.History[accountState.user.language]}
						</NavLink>
						<NavLink className="dropdown-item flex-row gap-2 align-items-center rounded" to="/account/storage#section_other">
							{Text.Others[accountState.user.language]}
						</NavLink>
					</div> */}
				</div>
			</div>
		</div>
	)
};